<template>
  <v-card>
    <v-card-title>
      <section-header>
        {{ $t('surveys.list_survey_teams') }}
      </section-header>
    </v-card-title>
    <v-card-text v-if="!!surveyShareTeams && surveyShareTeams.length === 0"
                 class="mb-4 text-body-2 text-sm-body-1">
      {{ $t('surveys.no_survey_team_items') }}
    </v-card-text>
    <v-card-text v-else
                 class="text-body-2 text-sm-body-1">
      {{ $t('surveys.list_survey_team_items') }}
      <div class="mt-2">
        <v-slide-x-transition group>
          <template v-for="team in surveyShareTeams">
            <survey-team-item :key="team.key"
                              :team="team">
            </survey-team-item>
          </template>
        </v-slide-x-transition>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import surveyShareApi from "@/api/surveyshare";
import SectionHeader from "@/components/SectionHeader";
import SurveyTeamItem from "@/components/Tenant/SurveyTeamItem";


export default {
  name: "ListSurveyTeamsCard",
  components: {SectionHeader, SurveyTeamItem},
  props: ['survey'],
  data() {
    return {
      surveyShares: [],
    }
  },
  methods: {
    async getSurveyShares() {
      this.surveyShares = await surveyShareApi.getSurveyShares(this.survey.key);
    },
  },
  computed: {
    surveyShareTeams() {
      if (this.surveyShares.length === 0) {
        return;
      }
      const teams = this.surveyShares.map((ss) => {
        if ((ss.teams.length > 0)) {
          const helperTeams = ss.teams.slice(0, ss.length);
          return helperTeams
        }
      })
      return teams.flat();
    },
  },
  mounted() {
    this.getSurveyShares();
  }
}
</script>

<style scoped>

</style>
